module.exports = __webpack_public_path__ + "static/media/coupon_graphic.1c812801.png";